export enum ObjectiveType {
    Annual = "Annual",
    Quarterly = "Quarterly",
}

export enum ObjectiveCode {
    AO = "AO",
    QO = "QO"
}

export class ObjectiveTypeMetadata {
    public static readonly Annual = new ObjectiveTypeMetadata(
        ObjectiveType.Annual,
        ObjectiveCode.AO,
        "Annual objective",
        "far fa-th-large",
    );
    public static readonly Quarterly = new ObjectiveTypeMetadata(
        ObjectiveType.Quarterly,
        ObjectiveCode.QO,
        "Quarterly objective",
        "far fa-cube",
    );

    public static readonly ByType: { [type in ObjectiveType]: ObjectiveTypeMetadata } = {
        [ObjectiveType.Annual]: ObjectiveTypeMetadata.Annual,
        [ObjectiveType.Quarterly]: ObjectiveTypeMetadata.Quarterly,
    };

    public static readonly ByCode: { [type in ObjectiveCode]: ObjectiveTypeMetadata } = {
        [ObjectiveCode.AO]: ObjectiveTypeMetadata.Annual,
        [ObjectiveCode.QO]: ObjectiveTypeMetadata.Quarterly,
    };

    /** Lookup by the enum value from the backend */
    public static readonly ByIntValue: { [intValue: number]: ObjectiveTypeMetadata } = {
        0: ObjectiveTypeMetadata.Annual,
        1: ObjectiveTypeMetadata.Quarterly,
    };

    private constructor(
        public readonly type: ObjectiveType,
        public readonly code: string,
        public readonly name: string,
        public readonly iconClass: string,
    ) { }

    public get pluralName() {
        return this.name + "s";
    }
}
